import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'app-capienze',
  templateUrl: './capienze.component.html',
  styleUrls: ['./capienze.component.css'],
  providers: [MessageService],
  
})
export class CapienzeComponent implements OnInit {
  
  parametri:any={
    posti_pranzo:0,
    posti_cena:0
  };
  struttureList:any[]=[];
  struttura_id=0;
  isLoading:boolean=true;


  constructor(
      private globalService: GlobalService,
      private apiService: ApiService,
      private messageService: MessageService,
  ) { }

  ngOnInit(): void {
    this.apiService.get('mensa/getstrutture',{}).subscribe((data)=>{
      this.struttureList=data.Result;
      if(this.globalService.loggedUser.struttura_id){
        this.struttura_id=this.globalService.loggedUser.struttura_id;
       
      } else {
        this.struttura_id=JSON.parse(localStorage.getItem('mensa_struttura_id'));
      
      }
      if(!this.struttura_id && this.struttureList.length>0){
        this.struttura_id=this.struttureList[0].value;
        this.changeStruttura({value:this.struttura_id});

      }
      this.apiService.post('mensa/mensa_capienza_listall',{struttura_id:this.struttura_id}).subscribe(data => {
      if(data.Result && data.Result[0]){
        this.parametri.posti_pranzo=data.Result[0].posti_pranzo;
        this.parametri.posti_cena=data.Result[0].posti_cena;
      }
    });
      this.isLoading=false;
    });
    
  }

  changeStruttura(event=null){
  if(event){
      this.struttura_id=event.value;
    }
    this.struttura_id=this.struttura_id;
    let f=this.struttureList.filter((x)=>x.value==this.struttura_id);
    localStorage.setItem('mensa_struttura_id',  JSON.stringify(this.struttura_id));
    if(!this.isLoading){
      window.location.reload();
    }
  
  }
  
  userCannotChangeStruttura(){
     if(this.globalService.loggedUser.struttura_id){
      return true;
     } else {
      return false;
     }
  }

  
  salva(){
    this.parametri.struttura_id=this.struttura_id;
    this.apiService.post('mensa/mensa_capienza_update',this.parametri).subscribe(data => {
      this.addSingle('success', 'Successo', 'Record aggiornato ');
    });
  }
  
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

}
